import { OnInit, OnDestroy, Component, Optional, Inject, HostListener } from '@angular/core';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DASplashPopup } from '../DAInterimPopup/da-splash-popup.component';
declare let dojoApp: any;

@Component({
    selector: 'dojo-DA-splash',
    templateUrl: './dojo-digital-advice-splash.component.html'
})
export class DojoSplashComponent implements OnInit, OnDestroy {
  community: string = '';
  queryParams: Params;
    shownewSplashPage: boolean = false;
    isMobile: boolean;
    shownewBMOSplashPage: boolean = false;
    constructor(private paramService: NxiWidgetParamsService ,
      @Optional() @Inject('AppSettings') appSettings: any,
      private dialog: MatDialog,
      private route: ActivatedRoute,
      private router: Router) {
         this.community = !!appSettings.ibdConfigMap && !!appSettings.ibdConfigMap.community ? appSettings.ibdConfigMap.community : '';
         this.isMobile = appSettings.deviceType == 'mobile';
    }

    getWidgetResponse()  {
        this.paramService.getWidgetParamsForMixin('digitalAdviseSplash').subscribe(
      resp => {
        let response: any = resp.response;
        console.log('response', response);
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderSplashPage(response);
        }
      },
     error => {
         console.log('error', error);
         return error;
      }
    );
  }

    ngOnInit() {
          if(this.community === 'tdwealth') {
             this.shownewSplashPage = true;
          }
          else if(this.community === 'bmodirect') {
            this.shownewBMOSplashPage = true;
         } 
          else {
            this.getWidgetResponse() ;
          }
          this.queryParams = this.route.snapshot.queryParams;
          if(this.queryParams.isNewUser) {
            this.dialog.open(DASplashPopup,  {width: this.isMobile ? '80vw' : '40vw'});
          }          
    }

    ngOnDestroy(): void {
        console.log('In DojoSplashComponent destroy method');
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroySplashPage();
        }
    }
    @HostListener('window:navigateToMixin', ['$event'])
    onNvaigateToMixinEvent(event: any) {
      if(event.detail) {
          this.router.navigate([event.detail.goTo], {queryParams: event.detail.reqParmas || {} });
      }
    }
}
